"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsOneOfAssertions = (assertions) => ((value) => {
    const passedAssertion = assertions.find((assertion) => assertion(value));
    return !!passedAssertion;
});
exports.default = valueIsOneOfAssertions;
